import { Component } from '@angular/core';

import { Button } from 'primeng/button';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';

@Component({
  selector: 'summit-confirmation',
  templateUrl: './confirmation.component.html',
  styleUrls: ['./confirmation.component.scss'],
  standalone: true,
  imports: [Button]
})
export class PrimeConfirmationComponent {
  constructor(
    public ref: DynamicDialogRef,
    public dialogConfig?: DynamicDialogConfig
  ) {}
  onNoClick(): void {
    this.ref.close(this.dialogConfig?.data.default ?? false);
  }
  close(_$event: any): void {
    this.ref.close(false);
  }

  confirm(): void {
    this.ref.close(true);
  }
}
